import { Hexagon } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HexagonIcon = createLucideIcon(Hexagon);
